import type { IndexingStatus } from '@vrzl/database';
import type { VStatusIconProps } from '@vrzl/ui';
import { Check, LoaderCircle, Timer, X, type LucideIcon } from 'lucide-react';

export const indexingStatusLabels: Record<IndexingStatus, string> = {
  NOT_INDEXED: 'Verwerking gepland',
  INDEXING: 'Wordt verwerkt',
  INDEXED: 'Verwerkt',
  FAILED_WITH_ERRORS: 'Verwerking mislukt',
};

export const indexingStatusDescriptions: Record<IndexingStatus, string> = {
  NOT_INDEXED:
    'Dit document is nog niet door AI verwerkt en daardoor nog niet doorzoekbaar.',
  INDEXING: 'Dit document wordt op dit moment door AI verwerkt.',
  INDEXED:
    'Dit document is succesvol door AI verwerkt en is doorzoekbaar.',
  FAILED_WITH_ERRORS:
    'Er is een probleem opgetreden bij de AI-verwerking van dit document.',
};

export const indexingStatusIcon: Record<
  IndexingStatus,
  { icon: LucideIcon; tone: NonNullable<VStatusIconProps['tone']>; spin?: boolean }
> = {
  NOT_INDEXED: { icon: Timer, tone: 'neutral' },
  INDEXING: { icon: LoaderCircle, tone: 'ghost', spin: true },
  INDEXED: { icon: Check, tone: 'success' },
  FAILED_WITH_ERRORS: { icon: X, tone: 'error' },
};
